/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_viewer = {
    readonly pdpHolidayShippingFeatureFlag: boolean | null;
    readonly relevantShipping: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_viewer" | "PdpSharedShippingInfoLink_viewer" | "PdpSharedShippingHolidayDelivery_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_viewer";
};
export type PdpRespSidebarBlurbShipping_viewer$data = PdpRespSidebarBlurbShipping_viewer;
export type PdpRespSidebarBlurbShipping_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_viewer",
  "selections": [
    {
      "alias": "pdpHolidayShippingFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpHolidayShipping"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpHolidayShipping\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "kind": "LinkedField",
      "name": "relevantShipping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRequestStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '75297623995a797603327f28ed459c3a';
export default node;
